import {Box, Button} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import {default as ReactQRCode} from 'qrcode.react';
import React from 'react';
import {Subtitle} from 'src/design/atoms/Typography';
import {FullScreenModal} from 'src/design/molecules/FullScreenModal';

/**
 * Renders a QR code for the given value with a "Fullscreen QR Code" button
 * that opens it full-screen for easy scanning.
 * @registry QR code generator — value in, scannable code + fullscreen view out.
 *
 * Ported from `library/elements/QrCodeGenerator`. Prop surface kept identical.
 */

export interface QrCodeGeneratorProps {
  title?: string;
  value: string;
}

export const QrCodeGenerator: React.FC<QrCodeGeneratorProps> = ({
  title,
  value,
}) => {
  const [open, options] = useDisclosure(false);

  const renderCode = () => (
    <ReactQRCode
      value={value}
      size={350}
      bgColor="#ffffff"
      fgColor="#000000"
      level="Q"
    />
  );

  return (
    <Box>
      <Box mb="md">{renderCode()}</Box>
      <Button size="sm" onClick={options.open}>
        Fullscreen QR Code
      </Button>
      <FullScreenModal title="" open={open} onCloseCallback={options.close}>
        <Box mt="xl">
          <Box mb="md">{title && <Subtitle text={title} />}</Box>
          {renderCode()}
        </Box>
      </FullScreenModal>
    </Box>
  );
};
